<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Function and Purpose
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="type"
              :label="this.localForm.type"
              :items="assetType"
              color="wplblue0"
              prepend-icon="factory"
              hint="asset or equipment type"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="cycle"
              :label="this.localForm.cycle"
              :items="assetLifecycle"
              color="wplblue0"
              prepend-icon="auto_mode"
              hint="design life cycle"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="obj"
              :label="this.localForm.obj"
              :items="assetFunctionalObjective"
              color="wplblue0"
              prepend-icon="adjust"
              hint="funtcional objective"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="mode"
              :label="this.localForm.mode"
              :items="assetOperatingMode"
              color="wplblue0"
              prepend-icon="toggle_on"
              hint="design operating mode"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="design"
              :label="this.localForm.design"
              :items="designBackupOptions"
              color="wplblue0"
              prepend-icon="drag_handle"
              hint="design setup"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="mob"
              :label="this.localForm.mob"
              :items="assetMobility"
              color="wplblue0"
              prepend-icon="emoji_transportation"
              hint="asset mobility"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.crit"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="warning"
            hint="business criticality"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.ref"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="sim_card_alert"
            hint="reference"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Asset System and Location
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.sys"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="schema"
            hint="functional system"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.syss"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="share"
            hint="sub system category"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.unit"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="data_usage"
            hint="facility unit"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.sec"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="segment"
            hint="facility section"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.map"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="map"
            hint="layout / map reference"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.grid"
            :rules="ruleMustBeFilledANDLessThan100"
            prepend-icon="grid_on"
            hint="grid or link"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Asset Capability and Operations
          </div>
        </v-layout>

        <v-layout row wrap class="ml-3 mr-2">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.des"
            label="Asset Facility Description"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="asset scope, capability, location of service"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>


        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import selectAsset from "@/data/options/mixins/selectAsset.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import facilityOptions from "@/data/options/mixins/facilityOptions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        type: "",
        des: "",
        obj: "",
        mob: "",
        mode: "",
        cycle: "",
        crit: "",
        ref: "",
        design: "",
        map: "",
        grid: "",
        sys: "",
        syss: "",
        unit: "",
        sec: ""
      },
      orgForm: {
        type: "",
        des: "",
        obj: "",
        mob: "",
        mode: "",
        cycle: "",
        crit: "",
        ref: "",
        design: "",
        map: "",
        grid: "",
        sys: "",
        syss: "",
        unit: "",
        sec: ""
      },
      des: "",
      type: "",
      obj: "",
      mob: "",
      mode: "",
      cycle: "",
      design: "",
      map: "",
      grid: "",
      sys: "",
      syss: "",
      unit: "",
      sec: ""
    };
  },
  watch: {
    // whenever question changes, this function will run
    type() {
      this.localForm.type = this.type;
      this.updateFormChar();
    },
    design() {
      this.localForm.design = this.design;
      this.updateFormChar();
    },
    obj() {
      this.localForm.obj = this.obj;
      this.updateFormChar();
    },
    mob() {
      this.localForm.mob = this.mob;
      this.updateFormChar();
    },
    mode() {
      this.localForm.mode = this.mode;
      this.updateFormChar();
    },
    cycle() {
      this.localForm.cycle = this.cycle;
      this.updateFormChar();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.type = this.getDetail.char.type;
    this.localForm.des = this.getDetail.char.des;
    this.localForm.cycle = this.getDetail.char.cycle;
    this.localForm.mob = this.getDetail.char.mob;
    this.localForm.obj = this.getDetail.char.obj;
    this.localForm.mode = this.getDetail.char.mode;
    this.localForm.design = this.getDetail.char.design;
    this.localForm.crit = this.getDetail.char.crit;
    this.localForm.ref = this.getDetail.char.ref;
    this.localForm.sys = this.getDetail.char.sys;
    this.localForm.syss = this.getDetail.char.syss;
    this.localForm.unit = this.getDetail.char.unit;
    this.localForm.sec = this.getDetail.char.sec;
    this.localForm.map = this.getDetail.char.map;
    this.localForm.grid = this.getDetail.char.grid;

    this.orgForm.type = this.getDetail.char.type;
    this.orgForm.des = this.getDetail.char.des;
    this.orgForm.cycle = this.getDetail.char.cycle;
    this.orgForm.mob = this.getDetail.char.mob;
    this.orgForm.obj = this.getDetail.char.obj;
    this.orgForm.mode = this.getDetail.char.mode;
    this.orgForm.design = this.getDetail.char.design;
    this.orgForm.sys = this.getDetail.char.sys;
    this.orgForm.syss = this.getDetail.char.syss;
    this.orgForm.unit = this.getDetail.char.unit;
    this.orgForm.sec = this.getDetail.char.sec;
    this.orgForm.map = this.getDetail.char.map;
    this.orgForm.grid = this.getDetail.char.grid;
    this.orgForm.crit = this.getDetail.char.crit;
    this.orgForm.ref = this.getDetail.char.ref;
  },
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    selectAsset,
    techOptions,
    facilityOptions
  ],
  // components: {
  //   RoleDevelopmentManageCard,
  //   RoleDevelopmentSummaryCard
  // },
  computed: {
    ...mapGetters(["getDetail", "getDetailChar"]),
    userStatus() {
      let status = null;
      if (this.getDetail.basic.act === true) {
        status = "Active";
      } else {
        status = "Not Active";
      }
      return status;
    }
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line

      if (
        this.localForm.sys !== this.orgForm.sys &&
        this.localForm.sys !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.sys = this.localForm.sys;
        // basic
        char.sys = this.localForm.sys;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.syss !== this.orgForm.syss &&
        this.localForm.syss !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.syss = this.localForm.syss;
        // basic
        char.syss = this.localForm.syss;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.unit !== this.orgForm.unit &&
        this.localForm.unit !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.unit = this.localForm.unit;
        // basic
        char.unit = this.localForm.unit;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.map !== this.orgForm.map &&
        this.localForm.map !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.map = this.localForm.map;
        // basic
        char.map = this.localForm.map;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.crit !== this.orgForm.crit &&
        this.localForm.crit !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.crit = this.localForm.crit;
        // basic
        char.crit = this.localForm.crit;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.ref !== this.orgForm.ref &&
        this.localForm.ref !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.ref = this.localForm.ref;
        // basic
        char.ref = this.localForm.ref;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.grid !== this.orgForm.grid &&
        this.localForm.grid !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.grid = this.localForm.grid;
        // basic
        char.grid = this.localForm.grid;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.design !== this.orgForm.design &&
        this.localForm.design !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.design = this.localForm.design;
        // basic
        char.design = this.localForm.design;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.mob !== this.orgForm.mob &&
        this.localForm.mob !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.mob = this.localForm.mob;
        // basic
        char.mob = this.localForm.mob;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 9); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.obj !== this.orgForm.obj &&
        this.localForm.obj !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.obj = this.localForm.obj;
        // basic
        char.obj = this.localForm.obj;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 10); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.cycle !== this.orgForm.cycle &&
        this.localForm.cycle !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.cycle = this.localForm.cycle;
        // basic
        char.cycle = this.localForm.cycle;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 11); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.mode !== this.orgForm.mode &&
        this.localForm.mode !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.mode = this.localForm.mode;
        // basic
        char.mode = this.localForm.mode;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 12); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (this.localForm.type !== this.orgForm.type) {
        // after the change re-assign new Local to Org
        this.orgForm.type = this.localForm.type;
        // basic
        char.type = this.localForm.type;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.83, 13); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.des !== this.orgForm.des &&
        this.localForm.des !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.des = this.localForm.des;
        // basic
        char.des = this.localForm.des;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.83, 14); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.sec !== this.orgForm.sec &&
        this.localForm.sec !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.sec = this.localForm.sec;
        // basic
        char.sec = this.localForm.sec;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.83, 15); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
